import OrbMap from "./orb-map";

export default OrbMap;